import React, { useState, useEffect } from 'react';
import { useReservations } from '../ReservationContext';

const TableModal = ({ isOpen, mode, table, onClose }) => {
  const { loading, zones, createTable, updateTable } = useReservations();

  const [formData, setFormData] = useState({
    table_id: '',
    table_name: '',
    table_type: '4-top',
    capacity: 4,
    zone_id: '',
  });

  useEffect(() => {
    if (mode === 'edit' && table) {
      setFormData({
        table_id: table.table_id,
        table_name: table.table_name,
        table_type: table.table_type,
        capacity: table.capacity,
        zone_id: table.zone_id || '',
      });
    } else {
      setFormData({
        table_id: '',
        table_name: '',
        table_type: '4-top',
        capacity: 4,
        zone_id: '',
      });
    }
  }, [mode, table]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let success;
    if (mode === 'edit') {
      success = await updateTable(table.table_id, formData);
    } else {
      success = await createTable(formData);
    }
    if (success) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{mode === 'create' ? 'Add Table' : 'Edit Table'}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form className="reservation-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Table ID *</label>
              <input
                type="text"
                value={formData.table_id}
                onChange={(e) => setFormData({ ...formData, table_id: e.target.value })}
                placeholder="T1, B2, etc."
                required
                disabled={mode === 'edit'}
              />
            </div>
            <div className="form-group">
              <label>Table Name</label>
              <input
                type="text"
                value={formData.table_name}
                onChange={(e) => setFormData({ ...formData, table_name: e.target.value })}
                placeholder="Table 1"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Type *</label>
              <select
                value={formData.table_type}
                onChange={(e) => setFormData({ ...formData, table_type: e.target.value })}
              >
                <option value="2-top">2-top</option>
                <option value="4-top">4-top</option>
                <option value="6-top">6-top</option>
                <option value="bar">Bar</option>
                <option value="large">Large</option>
              </select>
            </div>
            <div className="form-group">
              <label>Capacity *</label>
              <input
                type="number"
                min="1"
                max="20"
                value={formData.capacity}
                onChange={(e) => setFormData({ ...formData, capacity: parseInt(e.target.value) })}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Zone *</label>
            <select
              value={formData.zone_id}
              onChange={(e) => setFormData({ ...formData, zone_id: e.target.value })}
              required
            >
              <option value="">Select a zone...</option>
              {zones.map((zone) => (
                <option key={zone.zone_id} value={zone.zone_id}>
                  {zone.zone_name}
                </option>
              ))}
            </select>
          </div>

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Saving...' : 'Save Table'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TableModal;
